import { useQuery } from '@tanstack/react-query'
import { groceryListService } from './grocery-list.service'

export const GROCERY_LIST_QUERY_KEY = ['grocery-list'] as const

export function useGroceryList() {
  return useQuery({
    queryKey: GROCERY_LIST_QUERY_KEY,
    queryFn: () => groceryListService.getGroceryList(),
    staleTime: 0,
  })
}
